function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8953 10.6768V10.6768C12.0035 10.6768 10.4697 9.18204 10.4697 7.33841V7.33841C10.4697 5.49477 12.0035 4 13.8953 4V4C15.7871 4 17.3209 5.49477 17.3209 7.33841V7.33841C17.3209 9.18204 15.7871 10.6768 13.8953 10.6768Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.4373 10.6768V10.6768C28.5455 10.6768 27.0117 9.18204 27.0117 7.33841V7.33841C27.0117 5.49477 28.5455 4 30.4373 4V4C32.3291 4 33.8629 5.49477 33.8629 7.33841V7.33841C33.8629 9.18204 32.3291 10.6768 30.4373 10.6768Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4643 35.3871H11.3259L10.4695 27.0411L7.04395 26.2065V17.0259C7.04395 15.1823 8.57774 13.6875 10.4695 13.6875H17.3207C19.2124 13.6875 20.7462 15.1823 20.7462 17.0259V26.2065L17.3207 27.0411L16.4643 35.3871Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.0072 35.3871H27.8689L27.0125 27.0411L23.5869 26.2065V17.0259C23.5869 15.1823 25.1207 13.6875 27.0125 13.6875H33.8636C35.7554 13.6875 37.2892 15.1823 37.2892 17.0259V26.2065L33.8636 27.0411L33.0072 35.3871Z",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.49935 35.3869V26.5417C5.49935 25.5872 4.72561 24.8135 3.77116 24.8135V24.8135V24.8135C2.81671 24.8135 2.04297 25.5872 2.04297 26.5417V26.7848",
  stroke: "#00AEFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgParents = function SvgParents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parents.e9ff5a64.svg";
export { ForwardRef as ReactComponent };